export const CtaSection = ({ onLogin }) => (
  <section id="pricing" className="cta" data-testid="cta-section">
    <div className="cta-inner reveal">
      <h2 className="cta-title">
        A research workspace for <span className="gold">curious traders</span>.
      </h2>
      <p className="cta-sub">
        KIRA Markets is membership-based. Existing members, log in to your
        workspace below.
      </p>
      <button
        className="btn btn-gold btn-lg"
        onClick={onLogin}
        data-testid="cta-login-btn"
      >
        Sign In to KIRA Markets →
      </button>
    </div>
  </section>
);

export const LegalDisclaimer = () => (
  <section className="legal-disclaimer" data-testid="legal-disclaimer">
    <div className="legal-inner">
      <div className="legal-title">Important Disclaimer · Educational Purposes Only</div>
      <p>
        KIRA Markets is an <strong>educational market research platform</strong>.
        It does not provide personalized investment advice or portfolio management
        services. Nothing on this platform constitutes a recommendation to buy,
        sell, or hold securities.
      </p>
      <p>
        All investments in securities are subject to market risks. Historical
        research outcomes are displayed solely for educational purposes and are
        <strong> not indicative of future performance</strong>. Please consult a
        SEBI-registered investment adviser and conduct your own due diligence
        before making any investment decisions.
      </p>
    </div>
  </section>
);
